import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid, TableContainer } from "@material-ui/core";
import { formatAmount } from "utils/Utils";
import Table from "components/UpdateUi/Table/Table";
import { loanSchemeDetailTable } from "assets/properties/properties";

const LoanDetailsReview = ({ classes, loanDetails, eligibleAmountDetails }) => {
  const [installments, setinstallments] = useState([]);
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value}</label>
      </Grid>
    );
  };
  useEffect(()=>{
      if(loanDetails?.loanSchemeCalculation){
          parseIndicatorData(loanDetails?.loanSchemeCalculation)
      }
    },
    [loanDetails])
    const parseIndicatorData = async (res) => {
          let reportData = [];
          res &&
            res?.forEach((decisionDetails, index) => {
              let row = {
                adjustment: decisionDetails?.adjustment,
                adjustedAmount: formatAmount(decisionDetails?.adjustedAmount),
                adjustedAmountWithoutGst: formatAmount(decisionDetails?.adjustedAmountWithoutGst),
                cgstAmount: formatAmount(decisionDetails?.cgstAmount),
                chargeType: decisionDetails?.chargeType,
                excludingGst: decisionDetails?.excludingGst,
                gstApplicable: decisionDetails?.gstApplicable,
                igstAmount: formatAmount(decisionDetails?.igstAmount),
                sgstAmount: formatAmount(decisionDetails?.sgstAmount),
              };
              reportData.push(row);
            });
            setinstallments(reportData);
          };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Loan Details
        </h2>
      </Grid>

      <Grid item xs={12} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer}>
            {itemView("Eligible Loan Amount", formatAmount(eligibleAmountDetails) || "NA")}
            {itemView("Loan Amount", formatAmount(loanDetails?.loanAmount) || "NA")}
            {itemView("Interest Rate", Number(loanDetails?.interestRate) / 360 || "NA")}
            {itemView("Tenure In Months", loanDetails?.tenureInMonths || "NA")}
            {itemView("Total Charges", formatAmount(loanDetails?.totalCharges) || "NA")}
            {itemView("Total Gst", formatAmount(loanDetails?.totalGst) || "NA")}
            {itemView("Total Interest", formatAmount(loanDetails?.totalInterest) || "NA")}
            {itemView("Net Disbursal Amount", formatAmount(loanDetails?.netDisbursalAmount) || "NA")}
          </Grid>
        </Grid>
        {installments.length > 0 &&
      <TableContainer>
            <Table
              columns={loanSchemeDetailTable}
              rows={installments}
              styles="style"
              noPagination
            />
          </TableContainer>
    }
      </Grid>
    </Grid>
  );
};

LoanDetailsReview.propTypes = {
  classes: PropTypes.object,
  incomeDetails: PropTypes.object,
};

export default LoanDetailsReview;
